import { useEffect, useState } from "react";
import { APICall } from "../api";
import {
  Table,
  TableHeader,
  TableHeaderCell,
  TableRow,
  TableBody,
  TableCell,
  Button,
  Loader,
  Pagination,
} from "semantic-ui-react";
import FiltroRicerca from "./FiltroRicerca";
import FormInserimento from "./FormInserimento";
import ModaleModifica from "./ModaleModifica";
import { isUserAdmin } from "../utils/userCurrentlyLogged";

export default function TabellaRecord() {
  const [data, setData] = useState([]);
  const [modaleOpen, setModaleOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [activePage, setActivePage] = useState(1);
  const [itemsPerPage] = useState(20);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentFilters, setCurrentFilters] = useState("");
  const [selectedRowId, setSelectedRowId] = useState(null);
  const [modaleVediOpen, setModaleVediOpen] = useState(false);
  const [selectedUserVedi, setSelectedUserVedi] = useState(null);

  // al caricamento del componente carichiamo i dati dall'api, senza filtrarli
  useEffect(() => {
    fetchData(1, "");
  }, []);

  const handleOpenModale = (user) => {
    console.log("Utente selezionato:", user);
    setSelectedUser(user);
    setSelectedRowId(user.id);
    setModaleOpen(true);
  };

  const handleCloseModale = () => {
    setModaleOpen(false);
    setSelectedRowId(null);
    setSelectedUser(null);
  };

  const handleOpenModaleVedi = (user) => {
    setSelectedUserVedi(user);
    setModaleVediOpen(true);
  };

  const handleCloseModaleVedi = () => {
    setModaleVediOpen(false);
    setSelectedUserVedi(null);
  };

  const handleUpdateUser = async (user) => {
    console.log("Utente da aggiornare:", user);
    try {
      const response = await APICall.put(`/modifica/${user.id}`, user, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      console.log("I dati di response sono i seguenti:", response);
      console.log("I dati del form inviati al server sono i seguenti:", user);
      if (response.status >= 200 && response.status < 300) {
        console.log("I dati di response.data sono i seguenti:", response.data);
        console.log("Operatore modificato correttamente");
      } else {
        console.error("Errore nella modifica dell'operatore");
      }
    } catch (error) {
      console.error("Si è verificato un errore Axios:", error.message);
    }
    handleCloseModale();
    alert(
      "Record modificato correttamente, clicca OK per aggiornare la tabella"
    );
    fetchUpdatedTableData();
  };

  const handlePageChange = (e, { activePage }) => {
    setActivePage(activePage);
    fetchData(activePage, currentFilters);
  };

  const handleRowClick = (id) => {
    if (selectedRowId === id) {
      setSelectedRowId(null);
    } else {
      setSelectedRowId(id);
    }
  };

  const onSearch = (queryString) => {
    console.log("Chiamata OnSearch con QueryString: ", queryString);
    setActivePage(1); // torna alla prima pagina quando si applica un filtro
    setCurrentFilters(queryString); // come mai passiamo querystring a setcurrentfilters?
    fetchData(1, queryString);
  };

  const onDelete = async (id) => {
    const message = `Sei sicuro di voler eliminare l\`operatore con ID ${id}?`;
    const isConfirmed = window.confirm(message);
    if (!isConfirmed) {
      return;
    }
    console.log("Record eliminato num:", id);
    try {
      console.log("Sto per chiamare APICall.delete");
      const response = await APICall.delete(`/elimina/${id}`);
      console.log("Chiamata APICall.delete eseguita, risposta:", response);

      console.log("Sto per mostrare l'alert di eliminazione");
      alert(
        "Record eliminato correttamente, clicca OK per aggiornare la tabella"
      );
      fetchUpdatedTableData();
    } catch (error) {
      console.error("Errore durante l'eliminazione del record:", error);
    }
  };

  const fetchData = async (page = activePage, filters = currentFilters) => {
    setIsLoading(true);
    const offset = (page - 1) * itemsPerPage;

    try {
      const queryParams = filters
        ? `${filters}&limit=${itemsPerPage}&offset=${offset}`
        : `?limit=${itemsPerPage}&offset=${offset}`;
      console.log("Eseguo chiamata API con queryParams: ", queryParams);

      const response = await APICall.get(queryParams);
      console.log("Risposta API ricevuta: ", response.data);

      setData(response.data.result);
      setTotalRecords(response.data.numeroRecord);
      setIsLoading(false);
    } catch (error) {
      console.error("Errore dettagliato:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });
      setIsLoading(false);
    }
  };

  // ricarica i dati aggiornati dopo aver modificato un operatore nel database dal modale, mantenendo filtri e pagina attiva correnti
  const fetchUpdatedTableData = async () => {
    fetchData(activePage, currentFilters);
  };

  // Formatta la data secondo lo standard italiano
  function formatDateIta(dateString) {
    if (!dateString) {
      return "Non specificata";
    }
    const date = new Date(dateString);
    return date.toLocaleDateString("it-IT");
  }

  return (
    <>
      <FormInserimento onInsertSuccess={fetchUpdatedTableData} />
      <FiltroRicerca onSearch={onSearch} />
      <div className="table-container">
        <div className="headline-container">
          <h4 className="subtitle results-number">
            Numero di risultati: {totalRecords}
          </h4>
        </div>
        {isLoading && (
          <Loader active inline="centered">
            Caricamento dati...
          </Loader>
        )}
        <div className="table-wrapper">
          <Table celled striped selectable>
            <TableHeader className="table-header">
              <TableRow className="table-header-row">
                <TableHeaderCell className="azioni-header-cell">
                  Azioni
                </TableHeaderCell>
                {/* <TableHeaderCell>Modifica</TableHeaderCell> */}
                <TableHeaderCell>Id</TableHeaderCell>
                <TableHeaderCell>Data Consegna</TableHeaderCell>
                <TableHeaderCell>Codice</TableHeaderCell>
                {/* <TableHeaderCell>Qualifica</TableHeaderCell> */}
                {/* <TableHeaderCell>Nazionalità</TableHeaderCell> */}
                <TableHeaderCell>Cognome</TableHeaderCell>
                <TableHeaderCell>Nome</TableHeaderCell>
                <TableHeaderCell>Sesso</TableHeaderCell>
                <TableHeaderCell>Telefono</TableHeaderCell>
                <TableHeaderCell>Città</TableHeaderCell>
                {/* <TableHeaderCell>Provincia</TableHeaderCell> */}
                <TableHeaderCell>Cap</TableHeaderCell>
                {/* <TableHeaderCell>Coordinate</TableHeaderCell> */}
                {/* <TableHeaderCell>Zona</TableHeaderCell> */}
                <TableHeaderCell>ASL</TableHeaderCell>
                {/* <TableHeaderCell>Munic/Dist Roma</TableHeaderCell> */}
                {/* <TableHeaderCell>Email</TableHeaderCell> */}
                {/* <TableHeaderCell>Patente</TableHeaderCell> */}
                <TableHeaderCell>Disponibilità</TableHeaderCell>
                {/* <TableHeaderCell>Data Coll. Contatto</TableHeaderCell> */}
                {/* <TableHeaderCell>Offerta Assistenza</TableHeaderCell> */}
                {/* <TableHeaderCell>Tipo Collab.</TableHeaderCell> */}
                {/* <TableHeaderCell>Commenti</TableHeaderCell> */}
                {/* <TableHeaderCell>Creato da</TableHeaderCell> */}
                {/* <TableHeaderCell>Ultima Modifica</TableHeaderCell> */}
              </TableRow>
            </TableHeader>

            <TableBody>
              {data && Array.isArray(data) && data.length > 0 ? (
                data.map((item) => {
                  return (
                    <TableRow
                      key={item.id}
                      onClick={() => handleRowClick(item.id)}
                      style={{
                        backgroundColor:
                          selectedRowId === item.id ? "#e0e0e0" : "",
                        cursor: "pointer",
                      }}
                    >
                      <TableCell className="azioni-cell">
                        {isUserAdmin() && (
                          <Button
                            className="delete-button"
                            onClick={() => onDelete(item.id)}
                          >
                            Elimina
                          </Button>
                        )}
                        <Button
                          className="update-button"
                          onClick={() => handleOpenModale(item)}
                        >
                          Modifica
                        </Button>
                        <Button
                          className="view-button"
                          onClick={() => handleOpenModaleVedi(item)}
                        >
                          Vedi
                        </Button>
                      </TableCell>
                      <TableCell>{item.id}</TableCell>
                      <TableCell>{formatDateIta(item.data_consegna)}</TableCell>
                      <TableCell>{item.codice}</TableCell>
                      {/* <TableCell>{item.qualifica}</TableCell> */}
                      {/* <TableCell>{item.nazionalita}</TableCell> */}
                      <TableCell>{item.cognome}</TableCell>
                      <TableCell>{item.nome}</TableCell>
                      <TableCell>{item.sesso}</TableCell>
                      <TableCell>
                        <a href={`https://wa.me/39${item.telefono}`}>
                          {item.telefono}
                        </a>
                      </TableCell>
                      <TableCell>{item.citta}</TableCell>
                      {/* <TableCell>{item.provincia}</TableCell> */}
                      <TableCell>{item.cap}</TableCell>
                      {/* <TableCell>{item.coordinate}</TableCell> */}
                      {/* <TableCell>{item.zona}</TableCell> */}
                      <TableCell>{item.asl}</TableCell>
                      {/* <TableCell>{item.municipi_distretti_roma}</TableCell> */}
                      {/* <TableCell>
                        <a href={`mailto:${item.email}`}>{item.email}</a>
                      </TableCell> */}
                      {/* <TableCell>{item.patente}</TableCell> */}
                      <TableCell>{item.turni_accessi}</TableCell>
                      {/* <TableCell>
                        {formatDateIta(item.data_colloquio_contatto)}
                      </TableCell> */}
                      {/* <TableCell>{item.offerta_assistenza}</TableCell> */}
                      {/* <TableCell>{item.tipo_collaborazione}</TableCell> */}
                      {/* <TableCell>{item.commenti}</TableCell> */}
                      {/* <TableCell>{item.utente_primo_caricamento}</TableCell> */}
                      {/* <TableCell>{item.ultima_modifica}</TableCell> */}
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan="12">Nessun risultato trovato</TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </div>
        {totalRecords > 0 && (
          <div className="pagination-container">
            <Pagination
              activePage={activePage}
              totalPages={Math.ceil(totalRecords / itemsPerPage)}
              onPageChange={handlePageChange}
              boundaryRange={1}
              siblingRange={1}
              ellipsisItem={{ content: "...", icon: true }}
              firstItem={{ content: "«", icon: true }}
              lastItem={{ content: "»", icon: true }}
              prevItem={{ content: "‹", icon: true }}
              nextItem={{ content: "›", icon: true }}
            />
          </div>
        )}
      </div>
      <ModaleModifica
        open={modaleOpen}
        onClose={handleCloseModale}
        user={selectedUser}
        onUpdate={handleUpdateUser}
      />
      <ModaleModifica
        open={modaleVediOpen}
        onClose={handleCloseModaleVedi}
        user={selectedUserVedi}
        readOnly={true}
      />
    </>
  );
}
